// validation.js
export const validateEmployeeForm = (employee) => {
  const errors = {};

  // Валидация данных особи
  if (!employee.lastName?.trim()) {
    errors.lastName = 'Прізвище обов\'язкове для заповнення';
  }

  if (!employee.firstName?.trim()) {
    errors.firstName = 'Ім\'я обов\'язкове для заповнення';
  }

  // Валидация РНОКПП
  if (employee.rnokpp) {
    const rnokppRegex = /^\d{10}$/;
    if (!rnokppRegex.test(employee.rnokpp)) {
      errors.rnokpp = 'РНОКПП повинен містити рівно 10 цифр';
    }
  }

  // Валидация даты рождения
  if (employee.birthDate) {
    const birthDate = new Date(employee.birthDate);
    const today = new Date();
    const minDate = new Date();
    minDate.setFullYear(today.getFullYear() - 90);
    
    if (birthDate > today) {
      errors.birthDate = 'Дата народження не може бути у майбутньому';
    } else if (birthDate < minDate) {
      errors.birthDate = 'Дата народження не може бути більш ніж 90 років тому';
    }
  }

  // Валидация контактов
  if (employee.contacts && employee.contacts.length > 0) {
    const contactErrors = [];
    
    employee.contacts.forEach((contact, index) => {
      const contactError = {};
      
      if (!contact.value?.trim()) {
        contactError.value = 'Контактне значення обов\'язкове';
      } else {
        if (contact.type === 'Телефон') {
          // Минимальная валидация телефона - хотя бы 10 цифр
          const phoneDigits = contact.value.replace(/\D/g, '');
          if (phoneDigits.length < 10) {
            contactError.value = 'Телефон повинен містити щонайменше 10 цифр';
          }
        } else if (contact.type === 'Email') {
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailRegex.test(contact.value)) {
            contactError.value = 'Введіть коректний email';
          }
        }
      }
      
      if (Object.keys(contactError).length > 0) {
        contactErrors[index] = contactError;
      }
    });
    
    if (contactErrors.length > 0) {
      errors.contacts = contactErrors;
    }
  }

  // Валидация подразделений
  if (employee.departments && employee.departments.length > 0) {
    const departmentErrors = [];
    
    employee.departments.forEach((dept, index) => {
      const deptError = {};
      
      if (!dept.staffPositionId) {
        deptError.staffPositionId = 'Посада обов\'язкова для вибору';
      }
      
      if (dept.unit === undefined || dept.unit === null || dept.unit === '') {
        deptError.unit = 'Кількість одиниць обов\'язкова';
      } else {
        const unit = parseFloat(dept.unit);
        if (isNaN(unit) || unit <= 0 || unit > 3) {
          deptError.unit = 'Кількість одиниць повинна бути від 0.25 до 3';
        }
      }
      
      if (Object.keys(deptError).length > 0) {
        departmentErrors[index] = deptError;
      }
    });
    
    if (departmentErrors.length > 0) {
      errors.departments = departmentErrors;
    }
  } else {
    errors.departments = 'Хоча б один підрозділ обов\'язковий';
  }

  // Валидация дат в аттестации
  if (employee.attestation) {
    const { diplomaDate, lastAttestation, nextAttestation } = employee.attestation;
    
    if (diplomaDate) {
      const diploma = new Date(diplomaDate);
      const today = new Date();
      
      if (diploma > today) {
        errors.attestation = {
          ...errors.attestation,
          diplomaDate: 'Дата отримання диплому не може бути у майбутньому'
        };
      }
    }
    
    if (lastAttestation && nextAttestation) {
      const last = new Date(lastAttestation);
      const next = new Date(nextAttestation);
      
      if (next <= last) {
        errors.attestation = {
          ...errors.attestation,
          nextAttestation: 'Дата наступної атестації повинна бути пізніше за останню'
        };
      }
    }
    
    if (nextAttestation) {
      const next = new Date(nextAttestation);
      const today = new Date();
      
      if (next <= today) {
        errors.attestation = {
          ...errors.attestation,
          nextAttestation: 'Дата наступної атестації повинна бути у майбутньому'
        };
      }
    }
  }

  // Валидация даты первого рабочего дня
  if (employee.experience?.firstWorkDay) {
    const firstWorkDay = new Date(employee.experience.firstWorkDay);
    const today = new Date();
    
    if (firstWorkDay > today) {
      errors.experience = {
        ...errors.experience,
        firstWorkDay: 'Дата першого дня роботи не може бути у майбутньому'
      };
    }
  }

  // Валидация даты приказа
  if (employee.appointment?.date) {
    const appointmentDate = new Date(employee.appointment.date);
    const today = new Date();
    
    if (appointmentDate > today) {
      errors.appointment = {
        ...errors.appointment,
        date: 'Дата наказу не може бути у майбутньому'
      };
    }
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};

export const showValidationErrors = (errors, toast) => {
  // Показываем общие ошибки
  if (errors.lastName) {
    //toast.error(errors.lastName);
    return false;
  }
  
  if (errors.firstName) {
    //toast.error(errors.firstName);
    return false;
  }
  
  if (errors.rnokpp) {
    //toast.error(errors.rnokpp);
    return false;
  }
  
  if (errors.birthDate) {
    //toast.error(errors.birthDate);
    return false;
  }
  
  if (errors.departments && typeof errors.departments === 'string') {
    //toast.error(errors.departments);
    return false;
  }
  
  // Показываем ошибки контактов
  if (errors.contacts) {
    const firstContactError = Object.values(errors.contacts)[0];
    if (firstContactError?.value) {
      //toast.error(`Помилка в контакті: ${firstContactError.value}`);
      return false;
    }
  }
  
  // Показываем ошибки подразделений
  if (errors.departments && Array.isArray(errors.departments)) {
    const firstDeptError = Object.values(errors.departments)[0];
    if (firstDeptError?.staffPositionId) {
      //toast.error(`Помилка в посаді: ${firstDeptError.staffPositionId}`);
      return false;
    }
    if (firstDeptError?.unit) {
      //toast.error(`Помилка в одиницях: ${firstDeptError.unit}`);
      return false;
    }
  }
  
  // Показываем ошибки аттестации
  if (errors.attestation) {
    if (errors.attestation.diplomaDate) {
      //toast.error(errors.attestation.diplomaDate);
      return false;
    }
    if (errors.attestation.nextAttestation) {
      //toast.error(errors.attestation.nextAttestation);
      return false;
    }
  }
  
  // Показываем ошибки опыта работы
  if (errors.experience?.firstWorkDay) {
    //toast.error(errors.experience.firstWorkDay);
    return false;
  }
  
  // Показываем ошибки приказа
  if (errors.appointment?.date) {
    //toast.error(errors.appointment.date);
    return false;
  }
  
  return true;
};